import styled from "styled-components";

// display: ${(props: { isActive: boolean }) => (props.isActive ? 'block' : 'none')};
export const SnackbarContentStyled = styled.div<{ isActive: boolean }>`
  
  border-radius: 6px;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
  max-width: 364px;
  width: 364px;
  margin: 0 auto;
  position: fixed;
  bottom: -350px;
  left: 50%;
  margin-left: -182px;
  transition: transform 0.5s;
  &.opened {
    transform: translateY(-370px);
  }

  &.closed {
    transform: translateY(0);
  }

  &.success {
    background-color: #40AD5F;
  }

  &.error {
    background-color: #DC4547;
  }
  > div {
    color: white;
    display: flex;
    .column {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      padding: 0;
      &.left {
        width: 50px;
        flex: 0 0 50px;
      }

      &.right {
        width: 50px;
        flex: 0 0 50px;
        cursor: pointer;
      }

      &.center {
        flex: 1;
        font-family: Nunito Sans;
        font-style: normal;
        font-weight: bold;
        font-size: 18px;
        line-height: 22px;
        letter-spacing: 0.01em;
        text-align: left;
      }
    }
  }
`;